// component
import Iconify                      from '../../components/Iconify'
import * as React                   from 'react'
import { isLive }                   from '../../utils/envutils'

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />

const navConfig = [
    {
      key: 'services',
      title: 'Services',
      path: '/dashboard/services',
      icon: getIcon('material-symbols:list-alt'),
    },
    {
      key: 'messages',
      title: 'Messages',
      path: '/dashboard/messages',
      icon: getIcon('material-symbols:sms'),
    },
    {
      key: 'statistics',
      title: 'Statistics',
      path: '/dashboard/statistics',
      icon: getIcon('material-symbols:bar-chart'),
      children: [
        {
          key: 'statistics/messages',
          title: 'Message statistics',
          path: '/dashboard/statistics/messages',
          icon: getIcon('material-symbols:bar-chart'),
        },
        {
          key: 'statistics/shares',
          title: 'Shares statistics',
          path: '/dashboard/statistics/shares',
          icon: getIcon('material-symbols:bar-chart'),
        },
      ]
    },
    {
      key: 'logs',
      title: 'Logs',
      path: '/dashboard/errors',
      icon: getIcon('material-symbols:error'),
    },
    {divider: true, key: 'key-divider-1'},
    {
      key: 'providers',
      title: 'Providers',
      path: '/dashboard/providers',
      icon: getIcon('material-symbols:settings-input-antenna'),
    },
    {
      key: 'categories',
      title: 'Categories',
      path: '/dashboard/categories',
      icon: getIcon('material-symbols:format-list-bulleted'),
    },
    {
      key: 'partners',
      title: 'Partners',
      path: '/dashboard/partners',
      icon: getIcon('material-symbols:partner-exchange'),
    },
    {
      key: 'users',
      title: 'Users',
      path: '/dashboard/users',
      icon: getIcon('eva:people-fill'),
    },
    {divider: true, key: 'key-divider-0'},
    {
      key: 'phone-whitelist',
      title: 'Whitelist',
      path: '/dashboard/whitelist',
      icon: getIcon('material-symbols:person-check'),
    },
    {
      key: 'phone-blacklist',
      title: 'Blacklist',
      path: '/dashboard/blacklist',
      icon: getIcon('material-symbols:person-cancel'),
    },
    {
        key: 'sms-broadcast',
        title: 'Sms broadcast',
        path: '/dashboard/sms-broadcast',
        icon: getIcon('material-symbols:campaign'),
    },
    // fake provider - development only (gateway returns 404 on live)
    ...(isLive ? [] : [{
        key: 'fake-provider',
        title: 'Fake provider',
        path: '/dashboard/fake-provider',
        icon: getIcon('material-symbols:science'),
    }]),
]

export default navConfig
